<template>
  <svg width="24" height="24" viewBox="0 0 24 24">
    <path
      d="m10.43 12.01 5.934 6.021a1.127 1.127 0 0 1 0 1.583c-.43.435-1.13.44-1.566.011L8.86 13.602 7.286 12.01l1.568-1.597 5.956-6.037a1.11 1.11 0 0 1 1.57-.01c.444.45.444 1.156.01 1.596l-5.96 6.048z"
      :fill="disabled ? '#ccccc9' : '#737380'"
      fill-rule="evenodd"
    />
  </svg>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
